<template>
    <v-card>
        <v-card-title>Add Discovered Devices</v-card-title>
        <v-divider />


        <v-card-text class="mt-3">

            <v-expansion-panels multiple v-if="deviceType == 'ping'">
                <v-expansion-panel v-for="(device, idx) in $props.devices" :key="idx" :disabled="device.disabled">
                        <v-form :ref="`ping_target_${idx}`" :lazy-validation="true" v-model="device.formValid">
                        <v-expansion-panel-header color="#303030" style="text-align: left;">
                            <v-icon class="invalid-form-icon" color="#ff5252" v-if="!device.formValid">mdi mdi-alert</v-icon>
                            <span style="flex: none; margin-right: 30px;">{{ device.ip_address }}</span>
                            <span v-if="device.disabled">(Already Added)</span>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content eager color="#303030">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="device.add_ping_addr" color="#c42111" label="IP Address" :rules="[$store.state.validationFuncs.required(device.add_ping_addr, 'IP Address')]" />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="device.add_ping_name" color="#c42111" label="Target Name" :rules="[$store.state.validationFuncs.required(device.add_ping_name, 'Target Name')]" />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="device.add_ping_location" color="#c42111" label="Location" />
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-form>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels multiple v-if="deviceType == 'snmp'">
                <v-expansion-panel v-for="(device, idx) in $props.devices" :key="idx" :disabled="device.disabled">
                    <v-form :ref="`snmp_device_${idx}`" :lazy-validation="true" v-model="device.formValid">
                        <v-expansion-panel-header color="#303030">
                            <v-icon class="invalid-form-icon" color="#ff5252" v-if="!device.formValid">mdi mdi-alert</v-icon>
                            <span style="flex: none; margin-right: 30px;">{{ device.ip_address }}</span>
                            <span v-if="device.disabled">(Already Added)</span>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content eager color="#303030">
                            <v-row dense>
                                <v-col cols="12" md="8" lg="3">
                                    <v-text-field disabled v-model="device.addKey" color="#c42111" label="Host" :rules="[validation.required(device.addKey, 'Key'), validation.ipAddrOrSubnet(device.addKey)]" />
                                </v-col>
                                <v-col cols="12" md="4" lg="1">
                                    <v-select v-model="device.addVersion" :items="versionOptions" color="#c42111" label="Version" :rules="[validation.required(device.addVersion, 'Version')]" />
                                </v-col>
                                <v-col cols="12" md="12" lg="5">
                                    <v-text-field v-model="device.addCommunity" color="#c42111" label="Community String" :rules="[validation.required(device.addCommunity, 'Community')]" />
                                </v-col>
                                <v-col cols="12" md="4" lg="1">
                                    <v-autocomplete autocomplete="off" v-model="device.addHoursValue" :items="hoursOptions" color="#c42111" label="Frequeny Hours" :rules="[validation.min5Min(getFrequencySeconds(device.addHoursValue, device.addMinValue, device.addSecValue)), validation.max24Hours(getFrequencySeconds(device.addHoursValue, device.addMinValue, device.addSecValue))]" />
                                </v-col>
                                <v-col cols="12" md="4" lg="1">
                                    <v-autocomplete autocomplete="off" v-model="device.addMinValue" :items="minsOptions" color="#c42111" label="Frequeny Minutes" :rules="[validation.min5Min(getFrequencySeconds(device.addHoursValue, device.addMinValue, device.addSecValue)), validation.max24Hours(getFrequencySeconds(device.addHoursValue, device.addMinValue, device.addSecValue))]" />
                                </v-col>
                                <v-col cols="12" md="4" lg="1">
                                    <v-autocomplete autocomplete="off" v-model="device.addSecValue" :items="secOptions" color="#c42111" label="Frequeny Seconds" :rules="[validation.min5Min(getFrequencySeconds(device.addHoursValue, device.addMinValue, device.addSecValue)), validation.max24Hours(getFrequencySeconds(device.addHoursValue, device.addMinValue, device.addSecValue))]" />
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-autocomplete autocomplete="off" v-model="device.addPmGroups" multiple :items="$props.pmSnmpOptions" chips color="#c42111" label="PM Groups" :rules="[validation.requiredItem(device.addPmGroups, 'PM Groups')]" />
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-form>
                </v-expansion-panel>
            </v-expansion-panels>

        </v-card-text>

        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="saveClick" :disabled="canSave">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'NetworkDiscoveryAddDevices',
    props: ['deviceType', 'devices', 'pmSnmpOptions'],
    components: {

    },
    data: () => ({
        versionOptions: ['1', '2c'],
        hoursOptions: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
        minsOptions: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59],
        secOptions: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59],
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            ipAddrOrSubnet: (value) => ((/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/\d+$/.test(value)) || (/^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/.test(value)) || 'Invalid IP Address/Subnet'),
            min5Min: (value) => (value >= 300 || 'Minimum Frequency is 5 minutes'),
            max24Hours: (value) => (value <= 86400 || 'Maximum Frequency is 24 hours'),
            requiredItem: (value, fieldName) => (value.length > 0 || `A value is required`)
        },

    }),

    computed: {
        canSave() {
            return !this.$props.devices.some(d => d.disabled == false);
        }
    },

    methods: {
        getFrequencySeconds: function(hoursValue, minValue, secValue) {
            return ((parseInt(hoursValue) * 3600) + (parseInt(minValue) * 60) + parseInt(secValue));
        },

        saveClick: function() {
            let formRefs = [];
            if(this.deviceType == 'ping') {
                for(let i=0; i<this.$props.devices.length; i++) {
                    formRefs.push(`ping_target_${i}`);
                }
            }
            else if(this.deviceType == 'snmp') {
                for(let i=0; i<this.$props.devices.length; i++) {
                    formRefs.push(`snmp_device_${i}`);
                }
            }
            
            let self = this; 
            if(formRefs.every(f => (self.$refs[f].length && self.$refs[f][0].validate()))) {
                this.$emit('save');
            }
        }
    },

    mounted() {
    }
  
};
</script>

<style scoped>

    .section-title {
        display: block;
        font-size: 18px;
        font-weight: bold;
    }

    .invalid-form-icon {
        flex: none;
        height: 12px;
        margin-right: 15px;
    }

</style>
